// src/features/fourlink-config/hooks/useStorage.js

import { useEffect, useState } from 'react';
import {
  buildSnapshot,
  saveToLocalStorage,
  loadFromLocalStorage,
  hasMeaningfulSnapshotData,
} from '../utils/storage/localStorage';

export const useStorage = (state, onHydrate) => {
  const [hasHydrated, setHasHydrated] = useState(false);

  // Cargar estado inicial
  useEffect(() => {
    const saved = loadFromLocalStorage();
    if (saved && hasMeaningfulSnapshotData(saved) && typeof onHydrate === 'function') {
      onHydrate(saved);
    }
    setHasHydrated(true);
  }, [onHydrate]);

  // Auto-guardar cuando cambian las dependencias
  useEffect(() => {
    if (!hasHydrated) return;
    
    const snapshot = buildSnapshot(state);
    saveToLocalStorage(snapshot);
  }, [state, hasHydrated]);

  // Guardar antes de cerrar
  useEffect(() => {
    const onBeforeUnload = () => {
      const snapshot = buildSnapshot(state);
      saveToLocalStorage(snapshot);
    };
    
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', onBeforeUnload);
      return () => window.removeEventListener('beforeunload', onBeforeUnload);
    }
  }, [state]);

  return { hasHydrated };
};
